import React, { useEffect } from "react";
import RequestImage from "../assets/Images/request_submitted.png";
import Footer from "../components/Footer";
import { Stack, Typography, Container } from "@mui/material";
import Navbar from "../components/Navbar";
import _ from "lodash";
import { useNavigate } from "react-router-dom";

const UnderReview = () => {
  const navigate = useNavigate();
  useEffect(() => {
    let user = {};
    user = JSON.parse(localStorage.getItem("user-info"));
    if (_.isEmpty(user)) {
      navigate("/");
    }
  }, []);
  return (
    <>
      <Navbar />
      <Container>
        <div>
          <Stack className="d-flex">
            <Typography
              variant="h5"
              gutterBottom
              component="div"
              className="t-a-c"
            >
              Your profile is under review!
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              component="div"
              className="t-a-c"
            >
              You will soon be notified about your profile status
              <br />
              Thank you.
            </Typography>
          </Stack>

          <div className="t-a-c">
            <img src={RequestImage} alt="MenuIcon" />
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default UnderReview;
